import { addEvent, removeEvent } from '../utils/events';
import { addClasses, removeClasses, removeElement } from '../utils/html';

export class Dropdown {

  /**
   * @param  {Dom}    dropdown          container to hold dropdown
   * @param  {String} toggleSelector    selector toggle for dropdown reveal
   */
  constructor(dropdown, toggleSelector, menuSelector, allSelector) {
    this.dropdown = dropdown;

    if (!this.isEverythingOk()) {
      return;
    }

    this.toggleSelector = dropdown.querySelector(toggleSelector);
    this.menuSelector = dropdown.querySelector(menuSelector);
    this.allSelector = document.querySelectorAll(allSelector);
    this.isOpen = false;
    this.action = 'click';
    this.mask = null;
    this.direction = 'down';
    this.linksSelector = this.menuSelector.querySelectorAll('a');

    this.checkClickOff = this.checkClickOff.bind(this);
    this.toggle = this.toggle.bind(this);
    this.linkClick = this.linkClick.bind(this);
    this.removeMask = this.removeMask.bind(this);

    // Initialize dropdown
    this.init();
  }

  init() {
    // set direction of dropdown
    if (this.dropdown.hasAttribute('data-direction')) {
      if (this.dropdown.getAttribute('data-direction') === 'up') {
        this.direction = 'up';
        addClasses(this.dropdown, [ 'dropdown-up' ]);
      }
    }
    if (this.toggleSelector) {
      addEvent(this.toggleSelector, 'click', this.toggle);
      if (this.menuSelector) {
        this.menuSelector.style.width = `${ this.toggleSelector.offsetWidth }px`;
        if (this.direction === 'up') {
          this.menuSelector.style.bottom = `${ this.toggleSelector.offsetHeight }px`;
        }
        for (const link of this.linksSelector) {
          addEvent(link, 'click', this.linkClick);
        }
      }
    }
  }

  toggle(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  closeAll() {
    if (window.commonUI) {
      if (window.commonUI.dropdowns) {
        for (const dropdown of window.commonUI.dropdowns) {
          if (typeof dropdown.close === 'function') {
            dropdown.close();
            if (dropdown.mask && dropdown.maskTarget.contains(dropdown.mask)) {
              removeElement(dropdown.mask);
              dropdown.mask = null;
            }
          }
        }
      }
    }
  }
  /* eslint-disable no-console */
  open() {
    this.closeAll();
    addClasses(this.dropdown, [ (this.direction === 'up') ? 'dropdown-up-open' : 'dropdown-open' ]);
    addEvent(document, 'click', this.checkClickOff);
    this.isOpen = true;
  }
  /* eslint-enable no-console */
  removeMask() {
    if (this.maskTarget && this.maskTarget.contains(this.mask)) {
      removeElement(this.mask);
    }
    this.mask = null;
  }

  checkClickOff(event) {
    if (!this.dropdown.contains(event.target)) {
      this.close();
    }
  }

  linkClick() {
    this.close();
  }

  close() {
    this.isOpen = false;
    this.toggleSelector.blur();
    removeEvent(document, 'click', this.checkClickOff);
    if (this.action === 'click') {
      removeClasses(this.dropdown, [ 'dropdown-open', 'dropdown-up-open' ]);
    }
  }

  destroy() {
    this.close();
  }

  /* eslint-disable no-console */
  isEverythingOk() {
    if (!this.dropdown) {
      console.warn('CommonUI - Dropup - There\'s no dropdown found');
      return false;
    }
    return true;
  }
  /* eslint-enable no-console */
}

/**
 * Creates dropdown instances and returns array
 * @param  {Object} config
 */
export default function initDropdown(config = {}) {
  const { selector = '.dropdown, .dropup', toggleSelector = 'button[data-toggle="dropdown"]',
    menuSelector = '.dropdown-menu, .dropup-menu' } = config;
  const dropdowns = [];
  if (typeof selector === 'string') {
    for (const dropdown of document.querySelectorAll(selector)) {
      dropdowns.push(new Dropdown(dropdown, toggleSelector, menuSelector, selector));
    }
  }
  window.commonUI = (window.commonUI) ? window.commonUI : {};
  window.commonUI.dropdowns = dropdowns;
  return dropdowns;
}



// WEBPACK FOOTER //
// ./js/components/Dropdowns.js